import { IntranetContentKind } from '@gb-ticket/shared-types';

export type IntranetContentMenuHighlight = 'add' | 'change' | null;

export function intranetContentMenuActions(input: {
  canEdit: boolean;
  canDelete: boolean;
  canWrite: boolean;
  kind: string;
  highlighted: boolean;
}): {
  copy: true;
  edit: boolean;
  remove: boolean;
  highlight: IntranetContentMenuHighlight;
} {
  const canHighlight = input.canWrite && input.kind === IntranetContentKind.NEWS;
  return {
    copy: true,
    edit: input.canEdit,
    remove: input.canDelete,
    highlight: canHighlight ? (input.highlighted ? 'change' : 'add') : null,
  };
}

export type CalendarMenuEntry =
  | 'edit'
  | 'copy'
  | 'open'
  | 'publish'
  | 'unpublish'
  | 'highlight-add'
  | 'highlight-change'
  | 'highlight-clear'
  | 'acknowledgements'
  | 'delete';

/** Calendar card menu, in the order the newsroom page shows. */
export function calendarMenuEntries(input: {
  canEdit: boolean;
  canDelete: boolean;
  canWrite: boolean;
  canAcknowledge: boolean;
  kind: string;
  highlighted: boolean;
  isDraft: boolean;
}): CalendarMenuEntry[] {
  const entries: CalendarMenuEntry[] = [];
  if (input.canEdit) {
    entries.push('edit');
  }
  entries.push('copy', 'open');
  if (input.canEdit) {
    entries.push(input.isDraft ? 'publish' : 'unpublish');
  }
  const highlight = intranetContentMenuActions(input).highlight;
  if (highlight === 'add') {
    entries.push('highlight-add');
  }
  if (highlight === 'change') {
    entries.push('highlight-change', 'highlight-clear');
  }
  if (input.canAcknowledge) {
    entries.push('acknowledgements');
  }
  if (input.canDelete) {
    entries.push('delete');
  }
  return entries;
}

export async function copyIntranetArticleUrl(url: string): Promise<boolean> {
  try {
    const writeText = navigator.clipboard?.writeText.bind(navigator.clipboard);
    if (!writeText) {
      return false;
    }
    await writeText(url);
    return true;
  } catch {
    return false;
  }
}
